import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const UsersOverviewOne = () => {
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const [donutChartSeries, setDonutChartSeries] = useState([]);
    const [donutChartOptions, setDonutChartOptions] = useState({
        colors: ["#104a23", "#FF9F29", "#487FFF"], // Default colors
        labels: [],
        legend: {
            show: false,
        },
        chart: {
            type: "donut",
            height: 270,
            sparkline: {
                enabled: true,
            },
            margin: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            },
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            },
        },
        stroke: {
            width: 0,
        },
        dataLabels: {
            enabled: false,
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        position: "bottom",
                    },
                },
            },
        ],
    });
    const [loading, setLoading] = useState(true); // Add loading state

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await fetch(`${API_BASE_URL}/backend/complaints/complaints-dept-wise-count`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
    
                if (response.ok) {
                    const result = await response.json();
                    if (result.status) {
                        // Define the desired order of departments
                        const desiredOrder = ['Forest', 'Wildlife'];
                        
                        // Create a mapping of department names to their respective colors and counts
                        const departmentInfo = {
                            Forest: { color: "#104a23", count: 0 },
                            Wildlife: { color: "#FF9F29", count: 0 }
                        };
    
                        // Update counts from the API response
                        result.data.forEach(item => {
                            if (departmentInfo[item.department_name]) {
                                departmentInfo[item.department_name].count = item.count;
                            }
                        });
    
                        // Prepare series and labels in the desired order
                        const series = [];
                        const labels = [];
                        const colors = [];
    
                        desiredOrder.forEach(dept => {
                            if (departmentInfo[dept]) {
                                series.push(departmentInfo[dept].count);
                                labels.push(dept);
                                colors.push(departmentInfo[dept].color);
                            }
                        });
    
                        // Set the donut chart series and options
                        setDonutChartSeries(series);
                        setDonutChartOptions(prevOptions => ({
                            ...prevOptions,
                            labels: labels,
                            colors: colors,
                        }));
                    }
                } else {
                    console.error('Failed to fetch data:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };
    
        fetchData();
    }, [API_BASE_URL]);

    return (
        <div className="col-xxl-3 col-xl-6">
            <div className="card h-100 radius-8 border-0 overflow-hidden">
                <div className="card-body p-24">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-center">
                        <h6 className="mb-2 fw-bold text-lg text-center">Departmental Overview</h6>
                    </div>
                    {loading ? (
                        // Show skeleton placeholder for the chart
                        <Skeleton height={264} />
                    ) : (
                        // Render the chart when data is loaded
                        <ReactApexChart options={donutChartOptions} series={donutChartSeries} type="donut" height={264} />
                    )}
                    <ul className="d-flex flex-wrap align-items-center justify-content-between mt-3 gap-3">
                        {loading ? (
                            // // Show skeleton placeholders for the labels
                            Array.from({ length: 3 }).map((_, index) => (
                                <li key={index} className="d-flex align-items-center gap-2">
                                    <Skeleton circle width={12} height={12} />
                                    <Skeleton width={80} height={12} />
                                </li>
                            ))
                        ) : (
                            // Render the labels when data is loaded
                            donutChartOptions.labels.map((label, index) => (
                                <li key={index} className="d-flex align-items-center gap-2">
                                    <span className={`w-12-px h-12-px radius-2`} style={{ backgroundColor: donutChartOptions.colors[index] }} />
                                    <span className="text-secondary-light text-sm fw-normal">
                                        <span className="text-primary-light fw-semibold">{label}</span>
                                    </span>
                                </li>
                            ))
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default UsersOverviewOne;